/**
 * Tarih bicimleme yardimcilari.
 *
 * Backend'den gelen ISO string'ler UTC olarak yorumlanir (sonuna Z eklenir
 * eger zaten timezone offset yoksa). Sonra istenen IANA / Windows timezone'a
 * gore Turkce locale ile bicimlenir.
 *
 * Schedule.TimeZoneId genellikle Windows formatinda gelir ("Turkey Standard Time").
 * `Intl.DateTimeFormat` IANA bekler ("Europe/Istanbul"), bu yuzden bilinen
 * Windows -> IANA mapping yapiyoruz.
 */

const WINDOWS_TO_IANA: Record<string, string> = {
  'Turkey Standard Time': 'Europe/Istanbul',
  'GMT Standard Time': 'Europe/London',
  'W. Europe Standard Time': 'Europe/Berlin',
  'Eastern European Standard Time': 'Europe/Athens',
  UTC: 'UTC',
};

function resolveIanaTz(tz: string | null | undefined): string {
  if (!tz) return 'Europe/Istanbul';
  // IANA formati ise (icinde "/" varsa) oldugu gibi kullan
  if (tz.includes('/')) return tz;
  return WINDOWS_TO_IANA[tz] || 'Europe/Istanbul';
}

/**
 * UTC olarak gelen ISO string'i ekleyebilecegimiz hale getirir.
 * Sona Z yoksa ve timezone offset (+03:00 vb.) yoksa Z ekler.
 */
function ensureUtcIso(iso: string): string {
  if (/[zZ]$/.test(iso)) return iso;
  // Offset var mi? "+03:00" / "-0300" gibi
  if (/[+-]\d{2}:?\d{2}$/.test(iso)) return iso;
  return iso + 'Z';
}

/**
 * UTC ISO string'i verilen timezone'a gore tr-TR formatinda doner.
 * Ornek: formatLocal('2026-05-18T05:00:00', 'Turkey Standard Time') -> '18.05.2026 08:00'
 */
export function formatLocalDateTime(iso: string | null | undefined, timeZoneId?: string | null): string {
  if (!iso) return '-';
  try {
    const date = new Date(ensureUtcIso(iso));
    if (isNaN(date.getTime())) return iso;

    const tz = resolveIanaTz(timeZoneId);
    return new Intl.DateTimeFormat('tr-TR', {
      timeZone: tz,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  } catch {
    return iso;
  }
}

/**
 * Sadece saat bilesenini doner (gun ayni ise kullanmak icin).
 */
export function formatLocalTime(iso: string | null | undefined, timeZoneId?: string | null): string {
  if (!iso) return '-';
  try {
    const date = new Date(ensureUtcIso(iso));
    if (isNaN(date.getTime())) return iso;
    const tz = resolveIanaTz(timeZoneId);
    return new Intl.DateTimeFormat('tr-TR', {
      timeZone: tz,
      hour: '2-digit',
      minute: '2-digit',
    }).format(date);
  } catch {
    return iso;
  }
}
